export default "__VITE_ASSET__7d723d79__"